import { IconProps } from "../../../types/style";

const SmsEditSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V11.5"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.21 14.7698L15.6701 18.3098C15.5301 18.4498 15.4 18.7098 15.37 18.8998L15.18 20.2498C15.11 20.7398 15.45 21.0798 15.94 21.0098L17.29 20.8198C17.48 20.7898 17.75 20.6598 17.88 20.5198L21.4201 16.9798C22.0301 16.3698 22.3201 15.6598 21.4201 14.7598C20.5301 13.8698 19.82 14.1598 19.21 14.7698Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.7002 15.2798C19.0002 16.3598 19.8402 17.1998 20.9202 17.4998"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default SmsEditSVG;
